import { HttpClient } from "@angular/common/http";
import { CategoriaFiltroDTO, ICategoriaFiltroDTO, ITagDTO, ITagInfoDTO, TagDTO, TagInfoDTO } from "@DTOS";
import { Constants } from "@constants";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class TagsServiceBackend {
    constructor(private httpClient: HttpClient) {}

    public async getCategorias(): Promise<CategoriaFiltroDTO[]> {
        return await firstValueFrom(
            this.httpClient.get<ICategoriaFiltroDTO[]>(`${Constants.apiURL}/tag-types`).pipe(
                map(response => response.map(categoriaFiltro => new CategoriaFiltroDTO(categoriaFiltro)))
            )
        );
    }

    public async getTags(): Promise<TagDTO[]> {
        return await firstValueFrom(
            this.httpClient.get<ITagDTO[]>(`${Constants.apiURL}/tags`).pipe(
                map(response => response.map(tag => new TagDTO(tag)))
            )
        );
    }

    public async getTag(tagId: number): Promise<TagDTO> {
        const response = await firstValueFrom(this.httpClient.get<ITagDTO>(`${Constants.apiURL}/tags/${tagId}`));

        return new TagDTO(response);
    }

    public async getTagsPorCategoria(categoria: CategoriaFiltroDTO): Promise<TagDTO[]> {
        const response = await firstValueFrom(
            this.httpClient.get<ITagDTO[]>(
                `${Constants.apiURL}/tag-types/${categoria.id}/tags`
            )
        );

        return response.map(tag => new TagDTO(tag));
    }

    public async getTagInfo(tagId: number): Promise<TagInfoDTO> {
        const response = await firstValueFrom(this.httpClient.get<ITagInfoDTO>(`${Constants.apiURL}/tags/${tagId}/info`));

        return new TagInfoDTO(response);
    }

    public async agregarTagType(categoriaFiltro: CategoriaFiltroDTO) {
        const response = await firstValueFrom(
            this.httpClient.post<ICategoriaFiltroDTO>(
                `${Constants.apiURL}/tag-types`, categoriaFiltro.toJSON()
            )
        );

        return new CategoriaFiltroDTO(response);
    }

    public async agregarTag(tag: TagDTO) {
        const response = await firstValueFrom(this.httpClient.post<ITagDTO>(`${Constants.apiURL}/tags`, tag.toJSON()));

        return new TagDTO(response);
    }

    public async modificarTag(tag: TagDTO) {
        const response = await firstValueFrom(
            this.httpClient.put<ITagDTO>(
                `${Constants.apiURL}/tags/${tag.id}`, tag.toJSON()
            )
        );

        return new TagDTO(response);
    }
}
